import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Header from "../components/header";

import { doLoginRequest, doRegisterRequest } from "../state/actions";
import ResetPassword from "../components/resetPassword";

class Reset extends Component {
  render() {
    return (
      <Fragment>
        <Header showSubTitle="true" />
        <ResetPassword />
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...state.account
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      doRegisterRequest,
      doLoginRequest
    },
    dispatch
  );
};

const Routered = withRouter(connect(mapStateToProps, mapDispatchToProps)(Reset));

Routered.displayName = "Reset";

export default Routered;
